// extracted by mini-css-extract-plugin
export default {"productGrid":"E1-z","centerLink":"F1-z","productSection":"G1-z","item":"H1-z","ctaButton":"I1-z"};